import { defineStore } from 'pinia';

export const useLoaderStore = defineStore({
	id: 'loader',

	state: () => ({
		show_waveform_loader: true,
		show_settings_loader: false,
		show_loader: true,
		show_loading_progress: 25,
		show_event_label_loader: false,
		show_event_table_loader: false,
	}),

	actions: {
		toggleWaveformLoader(value = !this.show_waveform_loader) {
			this.show_waveform_loader = value;
		},
		toggleShowSettingsLoader(value = !this.show_settings_loader) {
			this.show_settings_loader = value;
		},
		toggleEventLabelLoader(value = !this.show_event_label_loader) {
			this.show_event_label_loader = value;
		},
		toggleEventTableLoader(value = !this.show_event_table_loader) {
			this.show_event_table_loader = value;
		},
	},
});
